import { Amenity, AmenityType } from './booking.model';
import { PetPolicy } from './pet-registry.model';

export interface Property {
  id: number;
  name: string;
  nameKey?: string;
  address: string;
  addressKey?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  propertyType: PropertyType;
  totalUnits: number;
  occupiedUnits: number;
  amenities: Amenity[];
  managementCompany: string;
  managementCompanyKey?: string;
  managerId: number;
  isActive: boolean;
  createdDate: Date;
  updatedDate: Date;
  description?: string;
  descriptionKey?: string;
  yearBuilt?: number;
  parkingSpaces?: number;
  petPolicy?: PetPolicy;
  rules?: PropertyRule[];
  contactInfo?: PropertyContactInfo;
}

export enum PropertyType {
  APARTMENT = 'apartment',
  CONDOMINIUM = 'condominium',
  TOWNHOUSE = 'townhouse',
  SINGLE_FAMILY = 'single_family',
  MIXED_USE = 'mixed_use',
  COMMERCIAL = 'commercial',
}

export interface OperatingHours {
  monday: PropertyDaySchedule;
  tuesday: PropertyDaySchedule;
  wednesday: PropertyDaySchedule;
  thursday: PropertyDaySchedule;
  friday: PropertyDaySchedule;
  saturday: PropertyDaySchedule;
  sunday: PropertyDaySchedule;
}

export interface PropertyDaySchedule {
  isOpen: boolean;
  openTime?: string;
  closeTime?: string;
  breakStartTime?: string;
  breakEndTime?: string;
}

export interface PropertyRule {
  id: number;
  propertyId: number;
  title: string;
  description: string;
  category: RuleCategory;
  isActive: boolean;
  effectiveDate: Date;
  expiryDate?: Date;
  priority: RulePriority;
}

export enum RuleCategory {
  NOISE = 'noise',
  PARKING = 'parking',
  PETS = 'pets',
  VISITORS = 'visitors',
  MAINTENANCE = 'maintenance',
  SAFETY = 'safety',
  COMMON_AREAS = 'common_areas',
  OTHER = 'other',
}

export enum RulePriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export interface PropertyContactInfo {
  managementOffice: string;
  emergencyPhone: string;
  maintenancePhone: string;
  email: string;
  website?: string;
  officeHours?: OperatingHours;
}

export interface Unit {
  id: number;
  propertyId: number;
  unitNumber: string;
  floor: number;
  bedrooms: number;
  bathrooms: number;
  squareFootage?: number;
  rentAmount?: number;
  currency?: string;
  isOccupied: boolean;
  residentId?: number;
  moveInDate?: Date;
  moveOutDate?: Date;
  amenities?: string[];
  parkingSpaces?: number;
  balcony?: boolean;
  furnished?: boolean;
  petFriendly?: boolean;
}
